
// import Swiper JS
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import $ from 'jquery';
import Packery from 'packery'; // importiere die Klasse

import 'swiper/css/navigation';
import 'swiper/css/pagination';



// jQuery-Plugin-Funktion registrieren
$.fn.packery = function (...args) {
  return new Packery(this[0], ...args);
};

(function () {
  var element = document.querySelector("#table-rounded-content");

  function scrollRight() {
    element.scrollLeft = element.scrollWidth;
  }


  /** Like Debounce but executes the function immediately 
   */
  function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if ((Date.now() - lastRan) >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }



  class DvinciMegaMenuMobile {
    constructor() {
      this.openMegaNavCurrent = null;
      this.openMainNavigationBtn = null;
      this.openMainSubMenu = null;
      this.mobileImgSrc = $('#branding-logo img').data('mobile');
      this.desktopImgSrc = $('#branding-logo img').data('desktop');
      this.init();
    }

    init() {
      this.toggleMobileMenu();
      this.setupMenuEvents();
      this.openLanguageDropDown();
      // this.closeOnEsc(); 
    }


    toggleMobileMenu() {
      const self = this;
      $(".hamburger-menu").on("click", function () {
        self.mobileMenuStateHandler(); // Übergibt das geklickte Element
      });

      this.closeOnEsc();
    }

    mobileMenuStateHandler() {
      const burgerMenu = $(".hamburger-menu");
      $(".mobile-menu-overlay").toggleClass("open");
      $("#site-header").toggleClass("mobile-menu-open");

      // 'this' referenziert jetzt die Instanz der Klasse
      if ($("#site-header").hasClass("mobile-menu-open")) {
        $('#branding-logo img').attr('src', this.mobileImgSrc);
      } else {
        $('#branding-logo img').attr('src', this.desktopImgSrc);
      }

      burgerMenu.toggleClass('opened');
      burgerMenu.attr('aria-expanded', burgerMenu.hasClass('opened'));
    }

    // Events for main nav and sub-menu's
    setupMenuEvents() {

      const throttledToggleSubMenu = throttle(this.toggleSubMenu, 300); // z.B. 300ms Sperre
      const throttledHandleMainNavigationChange = throttle(this.handleMainNavigationChange, 300);

      $(".menu-hauptmenue-mobil-container, .menu-hauptmenue-mobil-en-container").on("click keypress", ".menu-item-title", (e) => {
        if (e.target.tagName !== "A") {
          let isNoMainNavigation = !$(e.currentTarget).parent().parent().parent().hasClass("menu");

          if (isNoMainNavigation) {
            let subMenu = $(e.currentTarget).parent().next();
            throttledToggleSubMenu.call(this, subMenu, e.currentTarget);
          } else {
            throttledHandleMainNavigationChange.call(this, $(e.currentTarget));
          }
        }
      });
    }

    toggleSubMenu(subMenu, clickedButton) {
      $(subMenu).slideToggle();
      $(clickedButton).toggleClass("rotate-after");
    }


    handleMainNavigationChange($btn) {
      let openMainNavigation = $btn.closest(".menu-item-has-children");

      // close if clicked on the same menu-item 
      if (this.openMainNavigationBtn && this.openMainNavigationBtn.is($btn)) {
        this.closeMainNavigation();
        return;
      }

      // close previous opened menu
      if (this.openMainSubMenu) {
        this.closeMainNavigation();
      }

      // open new menu
      this.openMegaNavCurrent = openMainNavigation;
      this.openMainNavigationBtn = $btn;
      this.openMainSubMenu = openMainNavigation.children(".sub-menu");
      this.openMainSubMenu.slideDown();
      this.openMainNavigationBtn.addClass("rotate-after");
      openMainNavigation.addClass("mega-nav-current");
    }




    // closes current opened main navigation menu
    closeMainNavigation() {
      this.openMegaNavCurrent.removeClass("mega-nav-current");
      this.openMainSubMenu.slideUp();
      this.openMainNavigationBtn.removeClass("rotate-after");
      this.openMainSubMenu = null;
      this.openMainNavigationBtn = null;
      this.openMegaNavCurrent = null;
    }

    openLanguageDropDown() {
      $('.mobile-menu .wpml-ls-item').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass("actived-wpml");
        $(".sub-menu", this).slideToggle();
      });
    }

    closeOnEsc() {
      $(document).on("keydown", (e) => {
        if (e.key === "Escape") {
          if ($("#site-header").hasClass("mobile-menu-open")) {
            this.mobileMenuStateHandler();
          }
        }
      });
    }
  }

  new DvinciMegaMenuMobile();


  class DvinciMegaMenu {

    constructor() {
      this.openHeaderInstance = null;
      this.openSubMenuInstance = null;
      this.hoverEventDisabled = false;
      this.headerHeight = $("#site-header").height();
      this.init();

    }

    init() {
      this.tabOrClickEventMega();
      this.tabOrClickEventSmall();
      this.hoverEventMega();
      this.closeHeaderWhenClickOutside();
      this.closeHeaderOnHoverOut();
      this.closeHeaderOnEsc();
      this.barrierFreeMenu();
      this.closeLanguageDropDownClickOutside();
    }

    closeLanguageDropDownClickOutside() {
      $(".main-content").on("click", (e) => {
        let $wpmlItem = $(".wpml-ls-item");
        if ($wpmlItem.hasClass("actived-wpml")) {
          $wpmlItem.removeClass("actived-wpml").find(".sub-menu").fadeOut();
        }
      });
    }


    hoverEventMega() {
      $(
        ".header-navigation-wrapper > div > .menu > .menu-item-has-children"
      ).hover((e) => {

        if (this.hoverEventDisabled) return;
        // Mouseenter-Funktion
        const clickedElement = e.currentTarget;
        this.positionSubMenuLeft(clickedElement);
        this.closeHeader();
        this.openHeader(clickedElement);
      });
    }

    closeHeaderOnHoverOut() {
      $(".main-content").hover((e) => {
        if (this.openHeaderInstance) {
          this.closeHeader();
        }
      });
    }


    closeHeaderWhenClickOutside() {
      $(".main-content").on("click", (e) => {
        if (this.openHeaderInstance) {
          this.closeHeader();
        }
      });
    }


    closeHeaderOnEsc() {
      $(document).on("keydown", (e) => {
        if (e.key === "Escape") {
          if (this.openHeaderInstance) {
            this.closeHeader();
          }
        }
      });
    }


    // Small = Layer 1/2 Submenu
    tabOrClickEventSmall() {
      const self = this;
      $(
        ".first-childs-submenu .menu-item-has-children button.menu-item-title"
      ).on("click keypress", (e) => {
        if (e.target.tagName !== "A") {
          // go one up
          let subMenu = jQuery(e.currentTarget).parent().next();
          self.toggleSmallSubMenu(subMenu, e.currentTarget);
        }
      });
    }


    toggleSmallSubMenu(subMenu, clickedButton) {
      $(subMenu).slideToggle();
      $(clickedButton).toggleClass("rotate-after");
      this.openSubMenuInstance = subMenu;
    }


    // Mega = Layer 0 Navigation
    tabOrClickEventMega() {
      const self = this;
      $(
        ".header-navigation-wrapper > div > .menu > .menu-item-has-children"
      ).on("click keypress", (e) => {
        self.positionSubMenuLeft(e.currentTarget); // Use e.currentTarget to get the clicked element
        // check Event Type
        if (
          e.type === "click" ||
          (e.type === "keypress" && (e.which === 13 || e.which === 32))
        ) {
          if (e.target.tagName !== "A") {

            let mouseY = e.pageY;
            if (self.openHeaderInstance == e.currentTarget && mouseY < self.headerHeight) {
              self.temporarilyCloseMegaMenu();
              return;
            }

            const clickedElement = e.currentTarget; // Use e.currentTarget to get the element
            self.closeHeader();
            self.openHeader(clickedElement);
            e.preventDefault();
          }
        }
      });
    }


    // Close the Mega Menu temporarly to prevent reopening it immediately with hover
    temporarilyCloseMegaMenu() {
      this.closeHeader();
      this.hoverEventDisabled = true;
      setTimeout(() => { // deactivates temporary hover event 
        this.hoverEventDisabled = false;
      }, 800);
    }


    closeHeader() {
      if (!this.openHeaderInstance) return;

      $(this.openHeaderInstance)
        .find("button.menu-item-title")
        .first()
        .removeClass("rotate-after");

      $("html").removeClass("opened-megamenu");
      $("#site-header").removeClass("main-header-hover");
      $("#site-header").css("background-color", "transparent");
      $("#menu-hauptmenue, #menu-hauptmenue-en").css("border-right", "none");
      $(this.openHeaderInstance).removeClass("mega-nav-current");
      // $(this.openHeaderInstance).attr("aria-expanded", "false");
      jQuery(".header-contact").css("background-color", "transparent");

      this.openHeaderInstance = null;
    }


    openHeader(clickedElement) {
      let button = $(clickedElement).find("button.menu-item-title").first();
      jQuery(button).addClass("rotate-after");

      $("html").addClass("opened-megamenu");
      $("#menu-hauptmenue, #menu-hauptmenue-en").css("border-right", "2px solid #e0dedc");
      $("#site-header").addClass("main-header-hover");
      $("#site-header").css("background-color", "#fff");
      $(clickedElement).addClass("mega-nav-current");
      // $(clickedElement).attr("aria-expanded", "true");
      jQuery(".header-contact").css("background-color", "#FAFAF9");

      this.openHeaderInstance = clickedElement;
    }


    positionSubMenuLeft(clickedElement) {

      let screenSize = $(window).width();
      let screenPositonLeft = 0;

      if (screenSize > 1688) {
        screenPositonLeft = $("#menu-hauptmenue > li , #menu-hauptmenue-en > li").offset().left;
      }
      else {
        screenPositonLeft = $("#branding-logo img").offset().left;
      }
      $(clickedElement)
        .find(".sub-menu")
        .first()
        .css("left", screenPositonLeft)
        .css("max-width", "calc(100% - " + screenPositonLeft + "px)");
      $(clickedElement)
        .find(".header-footer .menu")
        .css("margin-left", screenPositonLeft);
      $(".header-main-section").css("left", "-" + screenPositonLeft);
    }


    barrierFreeMenu() {
      // adds svg to new page link in wp-navigation
      $(".link-to-new-page a").append(
        '<svg style="margin-left: 8px; position: relative; top: 2px;" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M15,10 L15,14 C15,15.1045695 14.1045695,16 13,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,3 C0,1.8954305 0.8954305,1 2,1 L6,1 L6,3 L2,3 L2,14 L13,14 L13,10 L15,10 Z M13.9971001,3.41421356 L7.70420685,9.70710678 L6.28999329,8.29289322 L12.5828865,2 L8.99710007,2 L8.99710007,0 L15.9971001,0 L15.9971001,7 L13.9971001,7 L13.9971001,3.41421356 Z" fill-rule="evenodd"/></svg> '
      );
      $(".link-to-new-page a").attr(
        "aria-label",
        myTranslations.linkToNewPageLabel
      );

      // for focus Tabindex
      $(
        ".header-navigation-wrapper > div > .menu > .menu-item-has-children > a"
      )
        .parent()
        .attr("tabindex", "0")
        .attr("role", "button")
        .attr("aria-haspopup", "true")
        .attr("aria-expanded", "false");

      // for aria-label "Kontakt" in contact menu
      $(".contact-menu-item > a").attr(
        "aria-label",
        myTranslations.contactLabel
      );

      // footer => social media links -> aria-label
      $(".menu-item-youtube > a").attr(
        "aria-label",
        myTranslations.youtubeLabel
      );
      $(".menu-item-instagram > a").attr(
        "aria-label",
        myTranslations.instagramLabel
      );
      $(".menu-item-tiktok > a").attr("aria-label", myTranslations.tiktokLabel);
      $(".menu-item-linkedin > a").attr(
        "aria-label",
        myTranslations.linkedinLabel
      );

      // WPML Language Switcher
      $(".contact-menu-mobile .menu > .wpml-ls-item").attr(
        "aria-label",
        myTranslations.languageSwitcherLabel
      );
      $(".header-contact .menu > .wpml-ls-item").attr(
        "aria-label",
        myTranslations.languageSwitcherLabel
      );
    }

  }
  const dvinciMegaMenu = new DvinciMegaMenu();

  /* -----------------  CLASS END ----------------- */

  $(".open-menu-mobile").on("click", function () {
    $("html").addClass("opened-megamenu");
    $("#site-header").addClass("mobile-main-header-menu");
    return false;
  });

  $(".close-menu-mobile").on("click", function () {
    $("html").removeClass("opened-megamenu");
    $("#site-header").removeClass("mobile-main-header-menu");
    $("#site-header").removeClass("main-header-hover"); // ****************added
    $(" > .sub-menu", this).stop(true, true).fadeOut("fast");
    return false;
  });

  $(".header-contact .menu > .wpml-ls-item").on("click", function (e) {
    $(this).toggleClass("actived-wpml");
    $(".sub-menu", this).fadeToggle();
  });

  $(".header-contact .men .menu-item-has-children > a").on(
    "click",
    function () {
      return false;
    }
  );
  $(".contact-menu-mobile .menu  > .wpml-ls-item").on("click", function () {
    $(this).toggleClass("actived-wpml");
    $(".sub-menu", this).fadeToggle();
  });

  $(".contact-menu-mobile .men .menu-item-has-children > a").on(
    "click",
    function () {
      return false;
    }
  );

  if ($(window).scrollTop() > 0) {
    $("body").addClass("scrolling");
    $("#site-header").addClass("fixed");
  } else {
    $("body").removeClass("scrolling");
    $("#site-header").removeClass("fixed");
  }

  $(window).scroll(function () {
    if ($(window).scrollTop() > 0) {
      $("body").addClass("scrolling");
      $("#site-header").addClass("fixed");
    } else {
      $("body").removeClass("scrolling");
      $("#site-header").removeClass("fixed");
    }
  });

  function onAir() {
    $(".on-air").each(function () {
      var start = new Date($(this).data("start"));
      var end = new Date($(this).data("end"));
      var now = new Date();
      if (now >= start && now <= end) {
        $(this).text("ON AIR");
        $(this).addClass("active");
      } else {
        $(this).text("");
        $(this).removeClass("active");
      }
    });
  }

  onAir();

  setInterval(onAir, 30000);

  $(".accordion-block").on("click", function () {
    if ($(this).hasClass("current")) {
      $(".accordion-block .inner-block").slideUp();
      $(".accordion-block").removeClass("current");
    } else {
      var get_this_height = $(this).outerHeight();
      $(".accordion-block .inner-block").slideUp();
      $(".inner-block", this).slideDown("slow", function () {
        get_header_height = $("#site-header").outerHeight();
        get_position = $(this).offset();
      });
      $(".accordion-block").removeClass("current");
      $(this).addClass("current");
    }
  });

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  $(".bubble-img").hover(
    function () {
      $(".bubble-img").not(this).addClass("scale-it");
    },
    function () {
      $(".bubble-img").not(this).removeClass("scale-it");
    }
  );

  var maximum = null;

  var count = $(".team-images .employees-images .bubble-img").length;

  // $(".employees-images .bubble-img").each(function (i) {
  //   position = $(this).position();
  //   height = $(this).height();
  //   item = position.top + height;
  //   maximum = item > maximum ? item : maximum;
  //   randomize = getRandomInt(150, 200);
  //   //console.log(randomize);
  //   //$(this).width(randomize).height(randomize);
  //   if (i + 1 === count) {
  //   }
  // });

  const $grid = $(".team-images.employees-images");
  if ($grid.length > 0) {
    $grid.packery({
      itemSelector: ".bubble-img",
      gutter: 10,
      originLeft: false,
      stamp: ".stamp",
      centered: {
        y: 300,
      },
    });
  } else {
    console.warn("Packery: Kein passendes Element gefunden.");
  }


  maximum = maximum + 8;

  //$(".employees-images").height(maximum);
  //console.log(maximum);

  $(".load-more-bubbles").click(function () {
    $(".employees-images").addClass("expanded");
    $(this).hide();
  });

  $(".group-accordeon").click(function () {
    $("p, ul, ol", this).slideToggle("fast", function () { });
  });

  if ($(".tabs-container-content").length) {
    if (window.location.hash) {
      var hash = window.location.hash.substring(1);
      // $('html,body').animate({scrollTop:$('#' + hash).offset().top}, 500);
      $(
        ".tabs-container-content .all-tabs > ul li, .tabs-container-content .all-tabs .tab-panel"
      ).each(function (index) {
        var data_id = $(this).attr("data-id");
        if (data_id == hash) {
          $(this).addClass("current");
        }
      });
    } else {
      $(".tabs-container-content .container-tabs-panels .tab-panel")
        .first()
        .addClass("current");
      $(".tabs-container-content .all-tabs > ul li")
        .first()
        .addClass("current");
    }

    $(
      ".tabs-container-content .all-tabs > ul a, .tabs-container-content .panel-heading a"
    ).on("click", function (e) {
      e.preventDefault();
      var get_anchor_id = $(this).attr("href").substr(1);
      $(
        ".tabs-container-content .all-tabs > ul li, .tabs-container-content .all-tabs .tab-panel"
      ).removeClass("current");
      $("[data-id=" + get_anchor_id + "]").addClass("current");
    });

    $(".partner-menu .sub-menu a").on("click", function (e) {
      var url = $(this).attr("href").substr(1);
      var index = url.indexOf("#");
      if (index !== -1) {
        var hash = url.substring(index + 1);
      }
      $(
        ".tabs-container-content .all-tabs > ul li, .tabs-container-content .all-tabs .tab-panel"
      ).removeClass("current");
      $("[data-id=" + hash + "]").addClass("current");
      e.preventDefault();
    });
  }

  $(".partner-block").hover(
    function () {
      $("img", this).hide();
      $("img.alt-image", this).fadeIn();
    },
    function () {
      $("img", this).fadeIn();
      $("img.alt-image", this).hide();
    }
  );

  $(".partner-block").each(function (index) {
    var get_url = $("a", this).attr("href");
    $(this).on("click", function () {
      window.location.href = get_url;
    });
  });

  $("#myalertbox .modal-body").text("pass your text here");

  $(".post-carousel-gallery").on(
    "click",
    "a[data-target='#partner-popup']",
    function () {
      var that = $(this).parent().parent();
      var get_html_modal = $(".hidden-content-modal", that).html();
      $(".replaced-content-modal").html(get_html_modal);
    }
  );

  $(
    ".one-pair-post-carousel-gallery a[data-target='#partner-popup'], .pair-post-carousel-gallery a[data-target='#partner-popup']"
  ).on("click", function () {
    var that = $(this).parent().parent();
    var get_html_modal = $(".hidden-content-modal", that).html();
    $(".replaced-content-modal").html(get_html_modal);
  });

  $("#partner-popup").on("hidden.bs.modal", function () {
    $(".replaced-content-modal").html(" ");
  });

  $(".partner-interviews .block-content").each(function (index) {
    if ($(this).attr("data-url")) {
      $(this).addClass("has-interview-url");
      var that = this;

      $(document).on("click", ".block-content", function (event) {
        if ($(this).attr("data-url")) {
          //console.log(this);
          window.open($(this).attr("data-url"), "_blank");
          event.preventDefault();
          return false;
        }
      });
    }
  });

  if ($(".interactive-map").length > 0) {
    function setCookie() {
      if ($(mapInfo).length > 0) {
        //console.log('test');
        if (
          document.cookie.indexOf("map_locations=") == -1 ||
          !cookieUpdated()
        ) {
          //console.log('setting cookie')
          const d = new Date();
          d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
          let expires = "expires=" + d.toUTCString();

          document.cookie =
            "map_locations=" + JSON.stringify(mapInfo) + ";" + expires;
        }
      }

      let mapLocations = getCookieValue("map_locations");
      //console.log(getCookieValue('map_locations'));

      return mapLocations;
    }

    const floorSelect = $(
      ".interactive-map .floor-control .wp-block-button__link"
    );
    const floor = $(".interactive-map .map");
    let areas = $(".interactive-map .map .area");
    let mapCookie = setCookie();
    const dialog = $(".interactive-map .dialog");
    const changeStatus = $(".interactive-map [href=#change-status]");
    //const contentContainer = dialog.find('.content');
    initMap();
    floorSelect.click(function (evt) {
      evt.preventDefault();
      floorToggle();
    });

    function initMap() {
      var currentFloor = "floor-4";
      var currentArea = "area-08";

      renderContent(currentFloor, currentArea);
      updateAreas();

      //$('.interactive-map .map:not(.hidden)').find('#area-07').addClass('focused');

      areas.click(function (evt) {
        evt.preventDefault();
        clearAreas();
        $(this).addClass("active");

        currentFloor = $(this).parents(".map").attr("data-floor");
        currentArea = $(this).attr("id");

        $(".interactive-map .map .arrow#" + currentArea).addClass("active");
        $(".interactive-map .map .check-icon#" + currentArea).addClass(
          "active"
        );

        // console.log({
        //   floor: currentFloor,
        //   area: currentArea
        // })

        renderContent(currentFloor, currentArea);
      });

      changeStatus.click(function (evt) {
        //console.log(mapCookie);
        evt.preventDefault();
        evt.stopPropagation();
        var visited = mapCookie[currentFloor][currentArea].visited === "true";
        //debugger;
        $(this).toggleClass("visited");
        $(this).find(".message").toggleClass("hidden");

        visited = !visited;

        mapCookie[currentFloor][currentArea].visited = visited.toString();

        updateCookie(mapCookie);
        updateAreas();
        // console.log({
        //   floor: currentFloor,
        //   area: currentArea,
        //   visited: visited
        // })
      });
    }

    function updateAreas() {
      $.each(mapCookie, function (floor, areas) {
        if (floor != "last-update") {
          $.each(areas, function (area, value) {
            //var floorClass = '.'+floor;
            var areaMap = $('[data-floor="' + floor + '"]').find("#" + area);
            if (areaMap.length > 0) {
              var visited = value.visited === "true";
              if (visited && !areaMap.hasClass("visited")) {
                areaMap.addClass("visited");
                $('[data-floor="' + floor + '"]')
                  .find(".check-icon#" + area)
                  .addClass("visited");
                $('[data-floor="' + floor + '"]')
                  .find(".arrow#" + area)
                  .addClass("visited");
              } else if (!visited && areaMap.hasClass("visited")) {
                areaMap.removeClass("visited");
                $('[data-floor="' + floor + '"]')
                  .find(".check-icon#" + area)
                  .removeClass("visited");
                $('[data-floor="' + floor + '"]')
                  .find(".arrow#" + area)
                  .removeClass("visited");
              }
            }
          });
        }
      });
    }

    function clearAreas() {
      areas.removeClass("active focused");
      $(".interactive-map .map .arrow").removeClass("active");
      $(".interactive-map .map .check-icon").removeClass("active");
    }

    function floorToggle() {
      floorSelect.toggleClass("active");
      floor.toggleClass("hidden");
      clearAreas();
      const visibleMap = $(".interactive-map .map:not(.hidden)");
      if (visibleMap.attr("data-floor") == "floor-4") {
        //renderContent( 'floor-4', 'area-08');
        visibleMap.find("#area-08").trigger("click");
      } else {
        //renderContent( 'floor-5', 'area-02' );
        visibleMap.find("#area-02").trigger("click");
      }
    }

    function updateCookie(cookie) {
      if (document.cookie.indexOf("map_locations=") >= 0) {
        const d = new Date();
        d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();

        document.cookie =
          "map_locations=" + JSON.stringify(cookie) + ";" + expires;
      }
    }

    function cookieUpdated() {
      if ($(mapInfo).length > 0) {
        const dates = {
          edit: mapInfo["last-update"],
          cookie: getCookieValue("map_locations")["last-update"],
        };

        if (dates.edit > dates.cookie) {
          return false;
        } else {
          return true;
        }
      }
    }

    function getCookieValue(name) {
      const cookies = document.cookie.split(";");
      // console.log(document.cookie);
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + "=")) {
          return JSON.parse(cookie.substring(name.length + 1, cookie.length));
        }
      }
      return null;
    }

    function renderContent(floor, area) {
      //var content = mapCookie[floor][area]['content'];
      //var visited = ( $('div[data-floor-content='+floor+'] [data-floor-id='+area+'] [data-floor-visited]').attr('data-floor-visited') === 'true');
      const status = dialog.find(".status");

      //console.log( $('div[data-floor-content='+floor+'] [data-floor-id='+area+'] [data-floor-visited]').attr('data-floor-visited') );

      var image = $(
        "div[data-floor-content=" +
        floor +
        "] [data-floor-id=" +
        area +
        "] [data-floor-image=fl-image]"
      ).html();
      var heading = $(
        "div[data-floor-content=" +
        floor +
        "] [data-floor-id=" +
        area +
        "] [data-floor-heading=fl-heading]"
      ).html();
      var text = $(
        "div[data-floor-content=" +
        floor +
        "] [data-floor-id=" +
        area +
        "] [data-floor-text=fl-text]"
      ).html();

      if (area == "stairs") {
        image = $(
          "div[data-floor-content=floor-5] [data-floor-id=stairs] [data-floor-image=fl-image]"
        ).html();
        heading = $(
          "div[data-floor-content=floor-5] [data-floor-id=stairs] [data-floor-heading=fl-heading]"
        ).html();
        text = $(
          "div[data-floor-content=floor-5] [data-floor-id=stairs] [data-floor-text=fl-text]"
        ).html();
      }

      $(".dialog-image").html(image);
      $(".dialog-header .heading").text(heading);
      $(".content").html(text);

      /*
      if ( content['image'] ) {
        dialog.find('.dialog-image').html('<img src="'+ content['image'] +'">');
      } else {
        dialog.find('.dialog-image').html('');
      }
      dialog.find('.dialog-header .heading').text(content['heading']);
      dialog.find('.content').text(content['text']);
      */
      if (area.startsWith("area-")) {
        var visited = mapCookie[floor][area].visited === "true";
        status.removeClass("hidden");
        if (visited) {
          status.addClass("visited");
          status.find(".message.visited").removeClass("hidden");
          status.find(".message.not-visited").addClass("hidden");
        } else {
          status.removeClass("visited");
          status.find(".message.visited").addClass("hidden");
          status.find(".message.not-visited").removeClass("hidden");
        }
      } else {
        status.addClass("hidden");
      }
    }
  }
})(jQuery);

// Zähle die Anzahl der Slides
var slideCount = document.querySelectorAll(
  ".testimonial-carousel-content .swiper-slide"
).length;

// Standard Swiper-Konfiguration
var swiperOptions = {
  centeredSlides: false,
  loop: true,
  slidesPerGroup: 1,
  loopAddBlankSlides: true,
  watchOverflow: true,
  navigation: {
    nextEl: ".testimonial-carousel-content .swiper-button-next",
    prevEl: ".testimonial-carousel-content .swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    600: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    782: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

// Überprüfe die Anzahl der Slides und passe die Loop-Einstellungen an
if (slideCount <= swiperOptions.slidesPerGroup) {
  swiperOptions.loop = false;
  swiperOptions.loopAddBlankSlides = false;
  jQuery(".testimonial-carousel-content .container").addClass(
    "container-no-after"
  );
}
// Initialisiere Swiper
var swiperTestimonial = new Swiper(
  ".testimonial-carousel-content .swiper",
  swiperOptions
);


// Standard Swiper-Konfiguration
var swiperOptions = {
  centeredSlides: false,
  loop: true,
  slidesPerGroup: 1,
  loopAddBlankSlides: true,
  watchOverflow: true,
  navigation: {
    nextEl: ".dvinci-slider .swiper-button-next",
    prevEl: ".dvinci-slider .swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    600: {
      slidesPerView: 1,
      spaceBetween: 40,
    },
    782: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
  },
};

// Überprüfe die Anzahl der Slides und passe die Loop-Einstellungen an
if (slideCount <= swiperOptions.slidesPerGroup) {
  swiperOptions.loop = false;
  swiperOptions.loopAddBlankSlides = false;
}
// Initialisiere Swiper
var swiperTestimonial = new Swiper(
  ".dvinci-slider .swiper",
  swiperOptions
);








var swiper = new Swiper(".custom-carousel-one ", {
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  slidesPerView: 1,
  spaceBetween: 20,
});

var swiper = new Swiper(".carousel-terciary", {
  navigation: {
    nextEl: ".caroulsel-loop-content .swiper-button-next",
    prevEl: ".caroulsel-loop-content .swiper-button-prev",
  },
  autoplay: {
    delay: 5000,
  },
  //slidesPerView: 3,
  //spaceBetween: 10,
  breakpoints: {
    480: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    782: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
});

var swiper = new Swiper(".stories-carousel", {
  loop: true,
  navigation: {
    nextEl: ".caroulsel-loop-content .swiper-button-next",
    prevEl: ".caroulsel-loop-content .swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  slidesPerView: 1,
  spaceBetween: 20,
});

var swiper = new Swiper(".references-carousel", {
  navigation: {
    nextEl: ".caroulsel-loop-content .swiper-button-next",
    prevEl: ".caroulsel-loop-content .swiper-button-prev",
  },
  a11y: false,
  //slidesPerView: 1,
  //spaceBetween: 20,
  breakpoints: {
    480: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
  },
});

var swiper = new Swiper(".image-carousel .swiper", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  centeredSlides: true,
  loop: true,
  preloadImages: true,
  updateOnImagesReady: true,
  autoplay: {
    delay: 4000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // autoplay: {
  //   delay: 5000,
  // },
});

var swiper = new Swiper(".one-pair-post-carousel-gallery", {
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: ".one-pair-post-carousel-gallery .swiper-button-next",
    prevEl: ".one-pair-post-carousel-gallery .swiper-button-prev",
  },
  //centeredSlides: true,
  //slidesPerView: 3,
  //spaceBetween: 10,
  breakpoints: {
    480: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    782: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

var swiper = new Swiper(".line-swiper", {
  // Optional parameters
  loop: false,
  direction: "horizontal",
  clickable: true,
  mousewheel: true,
  wrapperClass: "swiper-wrapper",
  slideClass: "swiper-slide",
  slidesPerView: 1,
  spaceBetween: 10,

  breakpoints: {
    540: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    1300: {
      slidesPerView: 4,
      spaceBetween: 50,
    },
    1740: {
      slidesPerView: 5,
      spaceBetween: 50,
    },
  },

  pagination: {
    el: ".line-swiper-pagination",
    type: "progressbar",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".line-swiper-button-next",
    prevEl: ".line-swiper-button-prev",
  },
});


/* Pricing */

(function () {




  const pricingSliders = document.querySelectorAll(".pricing-slider");

  if (pricingSliders.length > 0) {
    for (let i = 0; i < pricingSliders.length; i++) {
      const pricingSlider = pricingSliders[i];

      // Build the input object
      const pricingInput = {
        el: pricingSlider.querySelector("input"),
      };
      pricingInput.data = JSON.parse(
        pricingInput.el.getAttribute("data-price-input")
      );
      pricingInput.currentValEl = pricingSlider.querySelector(
        ".pricing-slider-value"
      );
      pricingInput.thumbSize = parseInt(
        window
          .getComputedStyle(pricingInput.currentValEl)
          .getPropertyValue("--thumb-size"),
        10
      );

      // Build the output array
      const pricingOutputEls = pricingSlider.parentNode.querySelectorAll(
        ".pricing-item-price"
      );
      const pricingOutput = [];
      for (let i = 0; i < pricingOutputEls.length; i++) {
        const pricingOutputEl = pricingOutputEls[i];
        const pricingOutputObj = {};
        pricingOutputObj.currency = pricingOutputEl.querySelector(
          ".pricing-item-price-currency"
        );
        pricingOutputObj.amount = pricingOutputEl.querySelector(
          ".pricing-item-price-amount"
        );
        pricingOutputObj.after = pricingOutputEl.querySelector(
          ".pricing-item-price-after"
        );
        pricingOutputObj.data = JSON.parse(
          pricingOutputEl.getAttribute("data-price-output")
        );
        pricingOutput.push(pricingOutputObj);
      }

      pricingInput.el.setAttribute("min", 0);
      pricingInput.el.setAttribute(
        "max",
        Object.keys(pricingInput.data).length - 1
      );
      !pricingInput.el.getAttribute("value") &&
        pricingInput.el.setAttribute("value", 0);

      handlePricingSlider(pricingInput, pricingOutput);
      window.addEventListener("input", function () {
        handlePricingSlider(pricingInput, pricingOutput);
      });
    }
  }

  function handlePricingSlider(input, output) {
    // output the current slider value
    if (input.currentValEl)
      input.currentValEl.innerHTML = input.data[input.el.value];
    // update prices
    for (let i = 0; i < output.length; i++) {
      const outputObj = output[i];
      if (outputObj.currency)
        outputObj.currency.innerHTML = outputObj.data[input.el.value][0];
      if (outputObj.amount)
        outputObj.amount.innerHTML = outputObj.data[input.el.value][1];
      if (outputObj.after)
        outputObj.after.innerHTML = outputObj.data[input.el.value][2];
    }
    handleSliderValuePosition(input);
  }

  function handleSliderValuePosition(input) {
    const multiplier = input.el.value / input.el.max;
    const thumbOffset = input.thumbSize * multiplier;
    const priceInputOffset =
      (input.thumbSize - input.currentValEl.clientWidth) / 2;
    input.currentValEl.style.left =
      input.el.clientWidth * multiplier - thumbOffset + priceInputOffset + "px";
  }
})();

function readmore() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more";
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less";
    moreText.style.display = "inline";
  }
}


// LOAD MORE
jQuery("#load_more_blog").click(function () {
  var total = jQuery("#total").val();
  var cate = jQuery("#category").val();
  var word = jQuery(".search-custom-form").val();
  var position = jQuery("#position").val();
  jQuery.ajax({
    url: WPURLS.siteurl + "/wp-admin/admin-ajax.php",
    data: {
      action: "load_more_blog",
      position: position,
      cate: cate,
      string: word,
    },
    type: "POST",
    beforeSend: function (xhr) {
      jQuery("#load_more_blog").text("Einen Moment..."); // change the button text, you can also add a preloader image
    },
    success: function (data) {
      console.log(data);
      jQuery("#load_more_blog").text("Mehr laden");
      jQuery(".content-search").html(jQuery(data.view).hide().fadeIn(500));
      jQuery("#total").val(data.total);
      var total = jQuery("#total").val();
      if (parseInt(total) <= parseInt(position) + 9) {
        jQuery("#load_more_blog").hide();
      } else {
        jQuery("#load_more_blog").show();
        jQuery("#position").val(position + 9);
      }
    },
  });
});

jQuery("#category").change(function () {
  jQuery("#position").val(9);
  var cate = jQuery("#category").val();
  jQuery.ajax({
    type: "post",
    url: WPURLS.siteurl + "/wp-admin/admin-ajax.php",
    data: {
      action: "search_custom_blog",
      position: 0,
      cate: cate,
    },
    success: function (resp) {
      console.log(resp);
      jQuery("#total").val(resp.total);
      if (!resp.success) {
        jQuery("#load_more_blog").hide();
      } else {
        if (parseInt(resp.total) <= 9) {
          jQuery("#load_more_blog").hide();
        } else {
          jQuery("#load_more_blog").show();
          jQuery("#position").val(9);
        }
      }
      jQuery(".content-search").html(resp.view);
    },
  });
});

jQuery(".search-custom-form").keyup(function () {
  var word = jQuery(".search-custom-form").val();
  jQuery.ajax({
    type: "post",
    url: WPURLS.siteurl + "/wp-admin/admin-ajax.php",
    data: {
      action: "search_custom_input_blog",
      string: word,
    },
    success: function (resp) {
      console.log(resp);
      jQuery("#total").val(resp.total);
      if (!resp.success) {
        jQuery("#load_more_blog").hide();
      } else {
        if (parseInt(resp.total) <= 9) {
          jQuery("#load_more_blog").hide();
        } else {
          jQuery("#load_more_blog").show();
          jQuery("#position").val(9);
        }
      }
      jQuery(".content-search").html(resp.view);
    },
  });
});


jQuery("#references-filter").change(function () {
  let checked = jQuery(this).find("input:checked");
  let names = [];

  checked.each(function (check) {
    names.push(jQuery(this).attr("name"));
  });

  jQuery.ajax({
    type: "post",
    url: WPURLS.siteurl + "/wp-admin/admin-ajax.php",
    dataType: "html",
    data: {
      action: "filter_referenzen",
      categories: names,
    },
    beforeSend: function (xhr) {
      jQuery(".references-grid .results").css("opacity", "0.3");
    },
    success: function (resp) {
      jQuery(".references-grid .results").html(resp);
      jQuery(".references-grid .results").css("opacity", "1");
    },
  });
});


